import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardUserRoutes = [
	{
		key: "users-customers",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/customers`,
		component: React.lazy(() => import("views/reward-views/users/customers/pages/RewardCustomersList")),
	},
	{
		key: "general-users",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/general-users`,
		component: React.lazy(() => import("views/reward-views/users/general-users/pages/GeneralUsersList")),
	},
	{
		key: "users-customer-segments",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/customer-segments`,
		component: React.lazy(() => import("views/reward-views/users/customer-segments/pages/CustomerSegmentsList")),
	},
	{
		key: "users-customer-segment-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/customer-segments/create`,
		component: React.lazy(() => import("views/reward-views/users/customer-segments/pages/CustomerSegmentForm")),
	},
	{
		key: "users-customer-segment-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/customer-segments/:id`,
		component: React.lazy(() => import("views/reward-views/users/customer-segments/pages/CustomerSegmentForm")),
	},
];
